import {
	ContextService,
	GamedayApiService
} from "@prestosports/prestostats-core/Services";
import {
	TOGGLE_SINGLE_COMPLETE,
	TOGGLE_DOUBLES_COMPLETE
} from "./tennis-constants";
import GamedayApiClient from "../../services/gameday-api-client";

GamedayApiService.setGamedayApiClient(GamedayApiClient);

export const toggleSingle = async (gameId, teamId, player, dispatch) => {
	const gameContext = await ContextService.getGameContext(gameId);
	const teamContext = gameContext.getTeamContext(teamId);

	if (teamContext.isSingle(player)) {
		teamContext.removeSingle(player);
	} else {
		teamContext.addSingle(player);
	}

	const savedGameContext = await ContextService.updateContext(gameContext);
	const savedTeamContext = savedGameContext.getTeamContext(teamContext.teamId);

	dispatch({
		type: TOGGLE_SINGLE_COMPLETE,
		payload: { teamContext: savedTeamContext && savedTeamContext.toJSON() }
	});
};

export const toggleDoubles = async (gameId, teamId, player, dispatch) => {
	const gameContext = await ContextService.getGameContext(gameId);
	const teamContext = gameContext.getTeamContext(teamId);

	if (teamContext.isDoubles(player)) {
		teamContext.removeDoubles(player);
	} else {
		teamContext.addDoubles(player);
	}

	const savedGameContext = await ContextService.updateContext(gameContext);
	const savedTeamContext = savedGameContext.getTeamContext(teamContext.teamId);

	dispatch({
		type: TOGGLE_DOUBLES_COMPLETE,
		payload: { teamContext: savedTeamContext && savedTeamContext.toJSON() }
	});
};
